(function () {
  if (!window.JIYUCHO_SCHEDULE || !window.JIYUCHO_SEATS_VIEW) return;

  // in memory cache to speed up prev next paging
  var VIEW_CACHE = {};

  // store key normalize
  function normalizeStoreKey(v) {
    var s = String(v || "").trim().toUpperCase();
    if (s === "FUTO" || s === "F") return "FUTO";
    return "JIYUCHO";
  }

  function getSameDayPolicy() {
    return window.JIYUCHO_RESERVATION_SAME_DAY || null;
  }

  function isSameDayPolicyEnabled(storeKey) {
    var policy = getSameDayPolicy();
    return !!(
      policy &&
      typeof policy.isEnabledForStore === "function" &&
      policy.isEnabledForStore(normalizeStoreKey(storeKey))
    );
  }

  function storeDisplayName(storeKey) {
    var k = normalizeStoreKey(storeKey);

    if (isEnglishPage()) {
      if (k === "FUTO") return "FUTO Rsvs Availability";
      return "JIYUCHO Rsvs Availability";
    }

    if (k === "FUTO") return "封灯予約枠状況";
    return "自由丁予約枠状況";
  }

  var WEEKS = 4;
  var WEEK_STARTS_ON_MONDAY = true;

  var GAS_TOKEN = "glow_in_small";
  // var GAS_VIEW_BASE_URL = "https://script.google.com/macros/s/AKfycbzgmI1yh9dAUtJO4BXNzkp9nuoX_GemFbM5P0ou2INTpDNlMlzxoGNKsDoJHY-nXxgQ/exec";
  var GAS_VIEW_BASE_URL = "https://script.google.com/macros/s/AKfycbxSqnveJmOq9PCXkrACJzzJyHhidR4sA8rM78V7T066Tkr1vdHxiU2-sizLtWBmXfuA/exec";

  function pad2(n) { return String(n).padStart(2, "0"); }
  function getJ(date) { return window.JIYUCHO_SCHEDULE.getJstComponents(date); }

  function getDowJst(date) {
    // 0=Sun .. 6=Sat in JST
    var d0 = (date instanceof Date) ? date : new Date(date);
    try {
      var C = window.JIYUCHO_SCHEDULE && typeof window.JIYUCHO_SCHEDULE.getJstComponents === "function"
        ? window.JIYUCHO_SCHEDULE.getJstComponents(d0)
        : null;
      if (C) {
        var n = null;
        if (typeof C.dow === "number") n = C.dow;
        else if (typeof C.dayOfWeek === "number") n = C.dayOfWeek;
        else if (typeof C.wday === "number") n = C.wday;
        else if (typeof C.weekday === "number") n = C.weekday;

        if (typeof n === "number" && isFinite(n)) {
          // allow either 0..6 or 1..7 style
          if (n === 7) return 0;
          if (n >= 1 && n <= 7) return n % 7;
          if (n >= 0 && n <= 6) return n;
          return ((n % 7) + 7) % 7;
        }
      }
    } catch (e) {}

    // compute from UTC millis (Japan has no DST)
    var t = d0.getTime() + (9 * 60 * 60000);
    var d = new Date(t);
    return d.getUTCDay();
  }

  // JIYUCHO only: show allowed times
  var ALLOW_JIYUCHO_WEEKDAY = {
    "13:00": 2,
    "13:30": 2,
    "15:30": 2,
    "16:00": 2,
    "16:30": 2
  };

  var ALLOW_JIYUCHO_WEEKEND_HOLIDAY = {
    "10:00": 2,
    "10:30": 2,
    "12:30": 2,    
    "13:00": 2,
    "13:30": 2,
    "15:30": 2,
    "16:00": 2,
    "18:00": 2,
    "18:30": 2
  };

  function filterAllowedRowsForJiyucho(rows, isWeekendOrHoliday) {
    var allow = isWeekendOrHoliday ? ALLOW_JIYUCHO_WEEKEND_HOLIDAY : ALLOW_JIYUCHO_WEEKDAY;
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      if (allow[rows[i].t]) out.push(rows[i]);
    }
    return out;
  }

  // JIYUCHO helpers
  function getAllowMapForJiyucho_(isWeekendOrHoliday) {
    return isWeekendOrHoliday ? ALLOW_JIYUCHO_WEEKEND_HOLIDAY : ALLOW_JIYUCHO_WEEKDAY;
  }

  // Expand to all allowed times.
  // If GAS provides "change points" only, treat availability as a step function.
  // If there is no slot data yet, fall back to the configured cap for that time.
  function expandAllowedRowsForJiyucho_(rows, isWeekendOrHoliday) {
    var allow = getAllowMapForJiyucho_(isWeekendOrHoliday) || {};
    var times = Object.keys(allow || {});
    if (!times.length) return Array.isArray(rows) ? rows : [];

    times.sort(function (a, b) {
      return timeStrToMin(a) - timeStrToMin(b);
    });

    var src = Array.isArray(rows) ? rows.slice() : [];
    src.sort(function (a, b) {
      return timeStrToMin(a.t) - timeStrToMin(b.t);
    });

    var out = [];
    var idx = 0;
    var curRow = null;

    for (var i = 0; i < times.length; i++) {
      var t = times[i];
      var tMin = timeStrToMin(t);
      if (!Number.isFinite(tMin)) continue;

      while (idx < src.length) {
        var r = src[idx];
        var rMin = timeStrToMin(r && r.t);
        if (!Number.isFinite(rMin)) {
          idx++;
          continue;
        }
        if (rMin <= tMin) {
          curRow = r;
          idx++;
          continue;
        }
        break;
      }

      var capV = allow[t];
      var capN = (typeof capV === "number" && isFinite(capV)) ? parseInt(capV, 10) : null;

      var avail = null;
      if (curRow && Number.isFinite(parseInt(curRow.avail, 10))) {
        avail = parseInt(curRow.avail, 10);
      } else if (capN !== null) {
        avail = capN;
      }

      if (avail === null || !Number.isFinite(parseInt(avail, 10))) continue;

      out.push({
        t: t,
        avail: parseInt(avail, 10),
        people: curRow && curRow.people != null ? parseInt(curRow.people, 10) : null,
        memo: curRow && curRow.memo ? curRow.memo : "",
        url: curRow && curRow.url ? curRow.url : ""
      });
    }

    return out;
  }

  // FUTO: allowed start times map (for business hours line)
  // 平日 13:00 から 10分刻み
  // 土日祝 10:00 から 10分刻み
  // 表示は 19:00 までにしたいので 最後の開始は 18:50 にする（close を 19:00 に合わせる）
  var ALLOW_FUTO_WEEKDAY = (function(){
    var out = {};
    var start = 13 * 60;
    var last  = 16 * 60 + 50;
    for (var m = start; m <= last; m += 10) out[minToHHMM(m)] = 12;
    return out;
  })();

  var ALLOW_FUTO_WEEKEND_HOLIDAY = (function(){
    var out = {};
    var start = 10 * 60;
    var last  = 18 * 60 + 50;
    for (var m = start; m <= last; m += 10) out[minToHHMM(m)] = 12;
    return out;
  })();

  function getAllowMapForFuto_(isWeekendOrHoliday) {
    return isWeekendOrHoliday ? ALLOW_FUTO_WEEKEND_HOLIDAY : ALLOW_FUTO_WEEKDAY;
  }
  function filterFutoAllowMapByLatestRule_(allowMap, dayDate) {
    var out = {};
    var src = allowMap || {};
    var keys = Object.keys(src);
    for (var i = 0; i < keys.length; i++) {
      var t = keys[i];
      if (passLatestStartRuleForSlot_("FUTO", dayDate, t)) out[t] = src[t];
    }
    return out;
  }
  function getAllowMapForFutoByDate_(isWeekendOrHoliday, dayDate) {
    return filterFutoAllowMapByLatestRule_(getAllowMapForFuto_(isWeekendOrHoliday), dayDate);
  }


  // Business hours line for the "all available" summary.
  // Uses the first and last allowed start times and assumes 30 minutes slot length for close time.
  // 汎用版: allowMap の最初と最後の開始時刻から営業時間ラインを作る
  // close は「最後に開始できる時刻 + slotMinutes」で算出
  function getBusinessHoursLineForStore_(storeKey, isWeekendOrHoliday, dayDateForRule) {
    var key = String(storeKey || "").trim().toUpperCase();

    var allow = key === "FUTO"
      ? (getAllowMapForFutoByDate_(isWeekendOrHoliday, dayDateForRule) || {})
      : (getAllowMapForJiyucho_(isWeekendOrHoliday) || {});

    var times = Object.keys(allow || {});
    if (!times.length) return "";

    times.sort(function (a, b) {
      return timeStrToMin(a) - timeStrToMin(b);
    });

    var openMin = timeStrToMin(times[0]);
    var lastStartMin = timeStrToMin(times[times.length - 1]);
    if (!Number.isFinite(openMin) || !Number.isFinite(lastStartMin)) return "";

    // 未定義関数を直接参照しない
    var slotMinutes;
    if (typeof getSlotMinutesByStoreKey_ === "function") {
      slotMinutes = getSlotMinutesByStoreKey_(key);
    } else {
      slotMinutes = (key === "FUTO" ? 10 : 30);
    }
    if (!Number.isFinite(slotMinutes) || slotMinutes <= 0) slotMinutes = 30;

    var closeMin = lastStartMin + slotMinutes;

    return minToHHMM(openMin) + " - " + minToHHMM(closeMin);
  }


  // 既存の呼び出しを崩したくない場合のラッパー
  function getBusinessHoursLineForJiyucho_(isWeekendOrHoliday, dayDateForRule) {
    return getBusinessHoursLineForStore_("JIYUCHO", isWeekendOrHoliday, dayDateForRule);
  }
  function getBusinessHoursLineForFuto_(isWeekendOrHoliday, dayDateForRule) {
    return getBusinessHoursLineForStore_("FUTO", isWeekendOrHoliday, dayDateForRule);
  }


  // Convert labels like "13:00 〜 18:00" or "13:00 to 18:00" into "13:00 - 18:00"
  function normalizeHoursRangeLabel_(s) {
    var v = String(s || "");
    v = v.replace(/\s*〜\s*/g, " - ");
    v = v.replace(/\s+to\s+/gi, " - ");
    return v;
  }

  function ymdKey(date) {
    var J = getJ(date);
    return String(J.y) + "-" + pad2(J.m) + "-" + pad2(J.d);
  }

  // YYYY/MM/DD for query param
  function ymdParam(date) {
    var J = getJ(date);
    return String(J.y) + "/" + pad2(J.m) + "/" + pad2(J.d);
  }

  function mdLabel(date) {
    var J = getJ(date);
    return String(J.m) + "/" + String(J.d);
  }

  function addDays(date, days) {
    return new Date(date.getTime() + days * 86400000);
  }

  function getDayStartJst(date) {
    var J = getJ(date);
    return window.JIYUCHO_SCHEDULE.jstDate(J.y, J.m, J.d, 0, 0, 0);
  }

  function startOfWeekJst(date) {
    var dow = getDowJst(date);
    var shift = WEEK_STARTS_ON_MONDAY ? ((dow + 6) % 7) : dow;
    return getDayStartJst(addDays(date, -shift));
  }

  function weekdayLabels() {
    return WEEK_STARTS_ON_MONDAY
      ? ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  }

  function buildGridDates(anchorDate) {
    var start = startOfWeekJst(anchorDate);
    var dates = [];
    for (var i = 0; i < WEEKS * 7; i++) dates.push(addDays(start, i));
    return { start: start, dates: dates };
  }

  function buildViewUrl(baseDateJstYmdSlash, storeKey) {
    var qs = new URLSearchParams({
      token: GAS_TOKEN,
      mode: "view",
      store: storeKey,
      weeks: String(WEEKS),
      date: baseDateJstYmdSlash
    });
    return GAS_VIEW_BASE_URL + "?" + qs.toString();
  }

  function pickDaySlots(byDay, date) {
    if (!byDay) return [];
    var k = ymdKey(date);          // YYYY MM DD
    if (byDay[k]) return byDay[k];

    var k2 = k.replace(/\-/g, "/"); // YYYY MM DD を YYYY MM DD っぽく
    if (byDay[k2]) return byDay[k2];

    return [];
  }

  function pickDayNotes(dayNotes, date) {
    if (!dayNotes) return [];
    var k = ymdKey(date);
    var notes = dayNotes[k];
    if (!notes) notes = dayNotes[k.replace(/\-/g, "/")];
    if (!notes) return [];
    if (Array.isArray(notes)) return notes;
    if (typeof notes === "string") return [notes];
    if (notes.memo) return [notes.memo];
    return [];
  }

  function hasDayBlock(dayBlocks, date) {
    return pickDayNotes(dayBlocks, date).length > 0;
  }


  function fmtTimeJst(d) {
    if (!(d instanceof Date) || isNaN(d.getTime())) return "";
    var j = new Date(d.getTime() + 9 * 60 * 60 * 1000);
    return pad2(j.getUTCHours()) + ":" + pad2(j.getUTCMinutes());
  }

  function timeStrToMin(t) {
    var m = /^\s*(\d{1,2})\s*:\s*(\d{2})\s*$/.exec(String(t || ""));
    if (!m) return NaN;
    var hh = parseInt(m[1], 10);
    var mm = parseInt(m[2], 10);
    if (!Number.isFinite(hh) || !Number.isFinite(mm)) return NaN;
    return hh * 60 + mm;
  }

  function isEnglishPage() {
    var lang = (document.documentElement && document.documentElement.getAttribute("lang"))
      ? String(document.documentElement.getAttribute("lang")).toLowerCase()
      : "";
    if (lang.indexOf("en") === 0) return true;

    if (window.Shopify && typeof window.Shopify.locale === "string") {
      var lc = window.Shopify.locale.toLowerCase();
      if (lc.indexOf("en") === 0) return true;
    }
    return false;
  }

  function getTxt() {
    if (isEnglishPage()) {
      return {
        closed: "Closed",
        plenty: "Plenty of seats",
        out: "No available start times",
        prev: "Prev",
        next: "Next",
        regular: "Regular hours"
      };
    }
    return {
      closed: "休み",
      plenty: "空席多数",
      out: "予約枠時間帯空席なし",
      prev: "前の4週",
      next: "次の4週",
      regular: "通常営業"
    };
  }

  function seatText(n) {
    var num = parseInt(n, 10);
    if (!Number.isFinite(num)) return "";
    if (num === 0) return isEnglishPage() ? "Full" : "満席";
    if (!isEnglishPage()) return String(num) + "枠";
    return String(num) + " " + (num === 1 ? "slot" : "slots");
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function safeUrl(url) {
    var s = String(url || "").trim();
    if (!s) return "";
    if (/^https?:\/\//i.test(s)) return s;
    return "";
  }

  function buildMemoHtml(timeLabel, memo, url, isEn, useTwoLine) {
    var memoText = escapeHtml(memo || "");
    var href = safeUrl(url);

    var textHtml = href
      ? "<a href='" + escapeHtml(href) + "' target='_blank' rel='noopener noreferrer'>" + memoText + "</a>"
      : memoText;

    var itemCls = "seats-cal-item lvl0" + (useTwoLine ? " to-close" : "");

    var html = "";
    html += "<div class='" + itemCls + "' data-time='' data-avail='0' data-to-close='0'>";
    html += "  <span class='t'>" + timeLabel + "</span>";
    html += "  <span class='a'>" + textHtml + "</span>";
    html += "</div>";
    return html;
  }

  function buildDayNotesHtml(notes) {
    if (!notes || !notes.length) return "";
    var html = "<div class='seats-cal-day-notes'>";
    for (var i = 0; i < notes.length; i++) {
      var memo = String(notes[i] || "").trim();
      if (!memo) continue;
      html += "<div class='seats-cal-day-note'>" + escapeHtml(memo) + "</div>";
    }
    html += "</div>";
    return html;
  }

  // find latest date key existing in byDay
  function findMaxDataKey(byDay) {
    if (!byDay) return "";
    var maxKey = "";
    for (var k in byDay) {
      if (!Object.prototype.hasOwnProperty.call(byDay, k)) continue;
      // simple lexical compare works for YYYY-MM-DD
      if (!maxKey || k > maxKey) maxKey = k;
    }
    return maxKey;
  }

  function ensureStyle() {
    var style = document.getElementById("seatsCalStyle");

    var TABLE_W = 840;

    var css = ""
      + ".seats-cal{max-width:100%;margin:48px auto;font-family:system-ui,-apple-system,Helvetica,Arial,Noto Sans JP,sans-serif}"
      + ".seats-cal-header{position:relative;display:flex;align-items:center;justify-content:space-between;gap:8px;margin:6px 0 20px;padding:0 8px}"
      + ".seats-cal-header .title{position:absolute;left:50%;transform:translateX(-50%);text-align:center;font-size:14px;font-weight:600;white-space:normal;pointer-events:none}"
      + ".seats-cal-header button{border:1px solid #ddd;background:#fff;padding:6px 8px;border-radius:10px;cursor:pointer;white-space:nowrap}.seats-cal-header button:disabled{opacity:0.35;cursor:default}"
      + ".seats-cal-header [data-act='prev']{justify-self:start}"
      + ".seats-cal-header [data-act='next']{justify-self:end}"
      + ".seats-cal-scroll{overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;padding:0 8px}"
      + ".seats-cal-table{border-collapse:separate;border-spacing:4px;table-layout:fixed;width:" + TABLE_W + "px;min-width:" + TABLE_W + "px;margin:0}"
      + ".seats-cal-table th{text-align:center;font-size:11px;color:#666;padding:4px 0;white-space:nowrap}"
      + ".seats-cal-cell{vertical-align:top;background:#fff;border:1px solid #eee;border-radius:12px;padding:8px;min-height:90px;min-width:110px}"
      + ".seats-cal-cell.is-today{border-color:#111}"
      + ".seats-cal-cell.is-closed{background:#fafafa}"
      + ".seats-cal-date{margin-bottom:10px;display:flex;justify-content:center;align-items:center;width:100%;padding:4px 0;border-radius:10px}"
      + ".seats-cal-date.kind-weekend{background:#fdecec;color:#7a1f1f}"
      + ".seats-cal-date.kind-weekday{background:#eaf2ff;color:#1f3b7a}"
      + ".seats-cal-date.kind-closed{background:#eaf7ef;color:#1f5a34}"
      + ".seats-cal-date-badge{display:inline-block;padding:0;border-radius:0;background:transparent;color:inherit;font-size:12px;line-height:18px;white-space:nowrap}"
      + ".seats-cal-list{display:flex;flex-direction:column;gap:4px}"
      + ".seats-cal-item{display:flex;justify-content:space-between;gap:6px;font-size:12px;line-height:1.2}"
      + ".seats-cal-item.to-close{display:block}"
      + ".seats-cal-item.to-close .t{display:block}"
      + ".seats-cal-item.to-close .a{display:block;text-align:right;margin-top:4px}"
      + ".seats-cal-item .t{color:#111;white-space:nowrap}"
      + ".seats-cal-item .a{color:#111;font-weight:700;white-space:nowrap}"
      + ".seats-cal-empty{font-size:12px;color:#999;font-weight:600}"
      + ".seats-cal-day-notes{display:flex;flex-direction:column;gap:3px;margin:-4px 0 7px}"
      + ".seats-cal-day-note{font-size:11px;line-height:1.35;color:#c82828;font-weight:700;word-break:break-word}"

      + ".seats-cal-item.regular-two-line{display:block}"
      + ".seats-cal-item.regular-two-line .t{display:block}"
      + ".seats-cal-item.regular-two-line .a{display:block;text-align:right;margin-top:4px}"

      + ".seats-cal-item.summary-two-line{display:block}"
      + ".seats-cal-item.summary-two-line .t{display:block}"
      + ".seats-cal-item.summary-two-line .a{display:block;text-align:right;margin-top:4px}"

      // color rules
      + ".seats-cal-item.lvl0 .t,.seats-cal-item.lvl0 .a{color:#c82828}"
      + ".seats-cal-item.lvlLow .t,.seats-cal-item.lvlLow .a{color:#b38f00}"
      + ".seats-cal-item.is-regular .a{font-weight:600}"
      + ".seats-cal-cell{cursor:pointer}"
      + ".seats-cal-item{cursor:pointer}"
      + "@media (min-width: 960px){"
      + "  .seats-cal-header{max-width:" + TABLE_W + "px;margin-left:auto;margin-right:auto;}"
      + "  .seats-cal-scroll{display:block;max-width:" + TABLE_W + "px;margin:0 auto;padding:0;}"
      + "  .seats-cal-table{margin:0 auto;}"
      + "}"
      + ".seats-cal-header button {font-size: 12px; border: none;}"
      + "@media (min-width: 960px){"
      + ".seats-cal-header button {font-size: 14px; border: none;}"
      + "}"
      
      // link style
      + ".seats-cal-item .a a{color:inherit;}"
      + ".seats-cal-item .a a:hover{opacity:.75}";

    if (!style) {
      style = document.createElement("style");
      style.id = "seatsCalStyle";
      document.head.appendChild(style);
    }
    style.textContent = css;
  }

  
  function pad2n(n) { return (n < 10 ? "0" : "") + String(n); }

  function minToHHMM(mins) {
    var m = parseInt(mins, 10);
    if (!Number.isFinite(m)) return "";
    if (m < 0) m = 0;
    var hh = Math.floor(m / 60);
    var mm = m % 60;
    return pad2n(hh) + ":" + pad2n(mm);
  }

  function getStoreRulesRoot() {
    if (window.JIYUCHO_SCHEDULE && window.JIYUCHO_SCHEDULE.STORE_RULES) return window.JIYUCHO_SCHEDULE.STORE_RULES;
    if (window.STORE_RULES) return window.STORE_RULES;
    if (window.JIYUCHO_SCHEDULE_UTILS && window.JIYUCHO_SCHEDULE_UTILS.STORE_RULES) return window.JIYUCHO_SCHEDULE_UTILS.STORE_RULES;
    return null;
  }

  function pickStoreRule(storeKey) {
    var root = getStoreRulesRoot();
    if (!root) return null;
    var k = normalizeStoreKey(storeKey);
    if (root[k]) return root[k];
    if (root.stores && root.stores[k]) return root.stores[k];
    return null;
  }

  function ymdHyphen(date) {
    var J = getJ(date);
    return String(J.y) + "-" + pad2n(J.m) + "-" + pad2n(J.d);
  }

  function ymdSlash(date) {
    var J = getJ(date);
    return String(J.y) + "/" + pad2n(J.m) + "/" + pad2n(J.d);
  }

  function matchSpecialHoursItem(item, date) {
    if (!item) return false;
    var a = ymdHyphen(date);
    var b = ymdSlash(date);

    var v = item.ymd || item.date || item.key || item.day;
    if (typeof v === "string") {
      var s = v.trim();
      return (s === a || s === b);
    }

    if (Number.isFinite(item.y) && Number.isFinite(item.m) && Number.isFinite(item.d)) {
      var J = getJ(date);
      return (item.y === J.y && item.m === J.m && item.d === J.d);
    }
    return false;
  }

  function getSpecialHoursForDate(storeKey, date) {
    var rule = pickStoreRule(storeKey);
    if (!rule || !rule.specialHours) return null;

    var sh = rule.specialHours;
    var a = ymdHyphen(date);
    var b = ymdSlash(date);

    if (typeof sh === "object" && !Array.isArray(sh)) {
      if (sh[a]) return sh[a];
      if (sh[b]) return sh[b];
      return null;
    }

    if (Array.isArray(sh)) {
      for (var i = 0; i < sh.length; i++) {
        if (matchSpecialHoursItem(sh[i], date)) return sh[i];
      }
    }

    return null;
  }

  function bizHoursDisplay(storeKey, date) {
    var sh = getSpecialHoursForDate(storeKey, date);

    var openStr = "";
    var closeStr = "";

    if (sh) {
      var openMin = (sh.openMin != null) ? sh.openMin : ((sh.startMin != null) ? sh.startMin : sh.open);
      var closeMin = (sh.closeMin != null) ? sh.closeMin : ((sh.endMin != null) ? sh.endMin : sh.close);

      openStr = (typeof openMin === "number") ? minToHHMM(openMin) : String(openMin || "").trim();

      if (typeof closeMin === "number") closeStr = minToHHMM(closeMin);
      else closeStr = String(closeMin || "").trim();
    }

    if (!openStr) openStr = minToHHMM(getDefaultOpenMinForDate(storeKey, date));

    var timeLabel = "";
    if (closeStr) {
      timeLabel = isEnglishPage() ? (openStr + " to " + closeStr) : (openStr + " 〜 " + closeStr);
    } else {
      timeLabel = isEnglishPage() ? (openStr + " to close") : (openStr + " 〜");
    }

    return { open: openStr, close: closeStr, label: timeLabel };
  }

  function getScheduleUtils() {
    if (window.JIYUCHO_SCHEDULE_UTILS) return window.JIYUCHO_SCHEDULE_UTILS;
    if (window.jiyucho_schedule_utils) return window.jiyucho_schedule_utils;
    return null;
  }

  function isWeekendOrHolidayByUtils(date) {
    var U = getScheduleUtils();

    function tryCall(fn) {
      if (typeof fn !== "function") return null;
      // try Date
      try { return !!fn(date); } catch (e1) {}
      // try ymd strings
      try { return !!fn(ymdHyphen(date)); } catch (e2) {}
      try { return !!fn(ymdSlash(date)); } catch (e3) {}
      // try components object
      try { var J = getJ(date); return !!fn({ y: J.y, m: J.m, d: J.d }); } catch (e4) {}
      // try raw J object
      try { var J2 = getJ(date); return !!fn(J2); } catch (e5) {}
      // try positional args
      try { var J3 = getJ(date); return !!fn(J3.y, J3.m, J3.d); } catch (e6) {}
      return null;
    }

    if (U) {
      var fns = [
        U.isWeekendOrHoliday,
        U.isWeekendOrHolidayJst,
        U.isWeekendOrHolidayInJapan,
        U.isWeekendHoliday,
        U.isWeekendOrHolidayJP,
        U.isWeekendOrHolidayJapan,
        U.isWeekendOrHolidayJa
      ];

      for (var i = 0; i < fns.length; i++) {
        var r = tryCall(fns[i]);
        if (r !== null) return r;
      }

      if (typeof U.isHolidayInJapan === "function") {
        var r2 = tryCall(U.isHolidayInJapan);
        if (r2 !== null) {
          var dow2 = getDowJst(date);
          return (dow2 === 0 || dow2 === 6) || r2;
        }
      }
    }

    // fallback
    var dow = getDowJst(date);
    var isWeekend2 = (dow === 0 || dow === 6);

    var isHoliday2 = false;
    try {
      if (window.JIYUCHO_SCHEDULE && typeof window.JIYUCHO_SCHEDULE.isHolidayInJapan === "function") {
        // this helper may accept Date or ymd
        try { isHoliday2 = !!window.JIYUCHO_SCHEDULE.isHolidayInJapan(date); } catch (e7) {}
        if (!isHoliday2) {
          try { isHoliday2 = !!window.JIYUCHO_SCHEDULE.isHolidayInJapan(ymdHyphen(date)); } catch (e8) {}
        }
      }
    } catch (e9) {}

    return isWeekend2 || isHoliday2;
  }


  function getDefaultOpenMinForDate(storeKey, date) {
    var isWH = isWeekendOrHolidayByUtils(date);

    // default rule
    // weekday: 13:00
    // weekend or holiday: 10:00
    // both stores follow the same default display
    return isWH ? (10 * 60) : (13 * 60);
  }

  function getDefaultCloseMinForDate(storeKey, date) {
    // only needed when specialHours does not define close
    // fallback to no close label (to close)
    return null;
  }

  function addMinutesToHHMM(hhmm, addMin) {
    if (!hhmm) return "";
    var m = /^\s*(\d{1,2})\s*:\s*(\d{2})\s*$/.exec(String(hhmm));
    if (!m) return "";
    var hh = parseInt(m[1], 10);
    var mm = parseInt(m[2], 10);
    if (!Number.isFinite(hh) || !Number.isFinite(mm)) return "";
    var mins = hh * 60 + mm + (addMin || 0);
    if (mins < 0) mins = 0;
    var nh = Math.floor(mins / 60) % 24;
    var nm = mins % 60;
    return pad2n(nh) + ":" + pad2n(nm);
  }

  function findChoiceInput(which) {
    var sels = which === "first"
      ? [
          "#ReservationForm-first_choice",
          "#ReservationForm-firstChoice",
          "#ReservationForm-first",
          "#ReservationForm-firstTime",
          "#ReservationForm-time_first",
          "#first_choice",
          "#firstChoice",
          "input[name='first_choice']",
          "input[name='firstChoice']",
          "input[name*='第一希望']",
          "input[id*='first_choice']",
          "input[id*='firstChoice']"
        ]
      : [
          "#ReservationForm-second_choice",
          "#ReservationForm-secondChoice",
          "#ReservationForm-second",
          "#ReservationForm-secondTime",
          "#ReservationForm-time_second",
          "#second_choice",
          "#secondChoice",
          "input[name='second_choice']",
          "input[name='secondChoice']",
          "input[name*='第二希望']",
          "input[id*='second_choice']",
          "input[id*='secondChoice']"
        ];

    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) return el;
    }
    return null;
  }

  function resolveActiveScheduleInput() {
    var s1 = document.getElementById('ReservationForm-schedule1');
    var s2 = document.getElementById('ReservationForm-schedule2');
    var activeId = window.__activeRescheduleScheduleInputId;
    if (activeId) {
      var a = document.getElementById(activeId);
      if (a) return a;
    }
    if (s1 && !s1.value) return s1;
    if (s2) return s2;
    return s1 || s2 || null;
  }

  function bindActiveScheduleInputTracker(){
    if (window.__activeRescheduleScheduleInputBound) return;
    window.__activeRescheduleScheduleInputBound = true;
    document.addEventListener('focusin', function(ev){
      var t = ev.target;
      if (!t || !t.id) return;
      if (t.id === 'ReservationForm-schedule1' || t.id === 'ReservationForm-schedule2') window.__activeRescheduleScheduleInputId = t.id;
    });
    document.addEventListener('click', function(ev){
      var t = ev.target;
      if (!t) return;
      if (t.id === 'ReservationForm-schedule1' || t.id === 'ReservationForm-schedule2') {
        window.__activeRescheduleScheduleInputId = t.id;
        return;
      }
      var ui = t.closest ? t.closest('.reserve-dt-ui[data-input-id]') : null;
      if (ui && ui.dataset && ui.dataset.inputId) window.__activeRescheduleScheduleInputId = ui.dataset.inputId;
    });
  }


  function getReserveDateTimeUiForInput_(input) {
    if (!input) return null;
    var next = input.nextElementSibling;
    if (
      next &&
      next.classList &&
      next.classList.contains("reserve-dt-ui")
    ) {
      return next;
    }
    if (input.id) {
      var candidates = document.querySelectorAll(".reserve-dt-ui[data-input-id]");
      for (var i = 0; i < candidates.length; i++) {
        if (String(candidates[i].getAttribute("data-input-id") || "") === input.id) {
          return candidates[i];
        }
      }
    }
    return null;
  }

  function scrollToScheduleField_(input) {
    var ui = getReserveDateTimeUiForInput_(input);
    var target = ui || input;
    if (!target || typeof target.scrollIntoView !== "function") return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        target.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      });
    });
  }

  function setChoiceDatetime(input, ymd, hhmm) {
    if (!input || !ymd || !hhmm) return null;
    if (input.disabled) return null;
    function isCompleteDateTimeValue(v) { return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(String(v || '')); }
    if (!input) return null;
    var v = String(ymd) + 'T' + String(hhmm);
    var other = input.id === 'ReservationForm-schedule1' ? document.getElementById('ReservationForm-schedule2') : document.getElementById('ReservationForm-schedule1');
    if (isCompleteDateTimeValue(v) && other && isCompleteDateTimeValue(other.value) && other.value === v) { return null; }
    input.value = v;
    try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (e1) {}
    try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e2) {}
    if (window.JIYUCHO_RESERVATION_DATETIME_UI && typeof window.JIYUCHO_RESERVATION_DATETIME_UI.selectReservationDateTimeForInput === 'function') {
      window.JIYUCHO_RESERVATION_DATETIME_UI.selectReservationDateTimeForInput(input, ymd, hhmm);
    }
    return input;
  }

  function selectedMenuTextForLatestRule_() {
    try {
      var isReschedule = location.pathname.indexOf('/pages/reschedule-cancel-rsv') >= 0;
      if (isReschedule) return String(window.__RESCHEDULE_MENU_FROM_RESPONSE__ || (window.currentReservation && window.currentReservation.menu) || window.RESCHEDULE_SOURCE_MENU || '');
      var menuEl = document.getElementById('ReservationForm-menu');
      if (!menuEl) return '';
      var opt = menuEl.options && menuEl.options[menuEl.selectedIndex];
      if (!opt) return String(menuEl.value || '');
      return [opt.id || '', opt.value || '', opt.text || ''].join(' ');
    } catch (e) {
      return '';
    }
  }

  function passLatestStartRuleForSlot_(storeKey, dayDate, timeText) {
    var rules = window.JIYUCHO_RESERVABLE_TIME_RULES;
    if (!rules || typeof rules.isDateTimeReservable !== 'function') return true;
    var m = String(timeText || '').match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return true;
    var base = (dayDate instanceof Date) ? dayDate : new Date(dayDate);
    if (!(base instanceof Date) || isNaN(base)) return true;
    var J = getJ(base);
    var dt = window.JIYUCHO_SCHEDULE.jstDate(J.y, J.m, J.d, parseInt(m[1], 10), parseInt(m[2], 10), 0);
    return rules.isDateTimeReservable({ store: normalizeStoreKey(storeKey), dateTime: dt, menu: selectedMenuTextForLatestRule_() });
  }

  function getMenuLimitOffsetMinutesForCalendar_() {
    var menu = selectedMenuTextForLatestRule_();
    var rules = window.JIYUCHO_RESERVABLE_TIME_RULES;

    if (rules && typeof rules.getMenuLimitOffsetMinutes === "function") {
      var fromRules = parseInt(rules.getMenuLimitOffsetMinutes(menu), 10);
      if (Number.isFinite(fromRules) && fromRules > 0) return fromRules;
    }

    if (rules && typeof rules.isLetterReservationMenu === "function") {
      return rules.isLetterReservationMenu(menu) ? 90 : 30;
    }

    return /t-price|①|一年後の自分へ手紙を書く|手紙|letter|future/i.test(menu) ? 90 : 30;
  }

  function rowTimeToDate_(dayStart, timeText) {
    var m = String(timeText || "").match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return null;
    var base = (dayStart instanceof Date) ? dayStart : new Date(dayStart);
    if (!(base instanceof Date) || isNaN(base)) return null;
    var J = getJ(base);
    return window.JIYUCHO_SCHEDULE.jstDate(J.y, J.m, J.d, parseInt(m[1], 10), parseInt(m[2], 10), 0);
  }

  function applyMenuOverlapAvailability_(rows, dayStart) {
    if (!rows || !rows.length) return rows || [];
    var offsetMs = getMenuLimitOffsetMinutesForCalendar_() * 60 * 1000;
    if (!Number.isFinite(offsetMs) || offsetMs <= 0) return rows;

    var fullRanges = [];
    for (var i = 0; i < rows.length; i++) {
      var fullStart = rowTimeToDate_(dayStart, rows[i] && rows[i].t);
      if (!fullStart || parseInt(rows[i].avail, 10) > 0) continue;
      fullRanges.push({
        from: fullStart.getTime(),
        to: fullStart.getTime()
      });
    }
    if (!fullRanges.length) return rows;

    return rows.map(function (row) {
      var start = rowTimeToDate_(dayStart, row && row.t);
      if (!start || parseInt(row.avail, 10) <= 0) return row;

      var startMs = start.getTime();
      var endMs = startMs + offsetMs;
      for (var j = 0; j < fullRanges.length; j++) {
        if (startMs <= fullRanges[j].to && endMs > fullRanges[j].from) {
          var next = {};
          for (var k in row) {
            if (Object.prototype.hasOwnProperty.call(row, k)) next[k] = row[k];
          }
          next.avail = 0;
          next.people = 0;
          next.memo = "";
          next.url = "";
          return next;
        }
      }
      return row;
    });
  }

  function filterRowsByLatestStartRule_(rows, storeKey, dayStart) {
    return (rows || []).filter(function(row){
      return passLatestStartRuleForSlot_(storeKey, dayStart, row && row.t);
    });
  }
  function getHoursLineFromRows_(rows) {
    if (!rows || !rows.length) return '';
    var first = rows[0] && rows[0].t;
    var last = rows[rows.length - 1] && rows[rows.length - 1].t;
    if (!first || !last) return '';
    return (first === last) ? first : (first + (isEnglishPage() ? " to " : " 〜 ") + last);
  }
function render(container, state, opt) {
    opt = opt || {};
    var isLoading = !!opt.loading;

    var dates = state.grid.dates;
    var todayKey = ymdKey(new Date());
    var TXT = getTxt();
    var STORE_KEY = state.storeKey;

    var sep = isEnglishPage() ? " to " : " 〜 ";

    var html = "";
    html += "<div class='seats-cal'>";
    html += "  <div class='seats-cal-header'>";
    html += "    <button type='button' data-act='prev'" + (state.disablePrev ? " disabled" : "") + ">" + TXT.prev + "</button>";
    html += "    <div class='title'>" + state.title + (isLoading ? "<div style='margin-top:4px;font-size:11px;color:#888'>Loading...</div>" : "") + "</div>";
    html += "    <button type='button' data-act='next'>" + TXT.next + "</button>";
    html += "  </div>";

    html += "  <div class='seats-cal-scroll'>";
    html += "    <table class='seats-cal-table'>";
    html += "      <thead><tr>";
    weekdayLabels().forEach(function (w) { html += "<th>" + w + "</th>"; });
    html += "      </tr></thead>";
    html += "      <tbody>";

    for (var r = 0; r < WEEKS; r++) {
      html += "<tr>";
      for (var c = 0; c < 7; c++) {
        var d = dates[r * 7 + c];
        var key = ymdKey(d);
        var dayStart = getDayStartJst(d);

        var isPastDay = key < todayKey;
        var isDayBlocked = hasDayBlock(state.dayBlocks, d);

        var okInfo = window.JIYUCHO_SCHEDULE.checkReservationDate(dayStart, STORE_KEY);
        var isClosed = !okInfo.ok;

        var isWH = isWeekendOrHolidayByUtils(dayStart);

        var badgeKind = isClosed
          ? "kind-closed"
          : (isWH ? "kind-weekend" : "kind-weekday");

        var cls = "seats-cal-cell";
        if (key === todayKey) cls += " is-today";
        if (isClosed) cls += " is-closed";
        if (isDayBlocked) cls += " is-day-blocked";

        html += "<td class='" + cls + "' data-ymd='" + key + "' data-store='" + STORE_KEY + "'>";
        html += "  <div class='seats-cal-date " + badgeKind + "'>";
        html += "    <span class='seats-cal-date-badge'>" + mdLabel(d) + "</span>";
        html += "  </div>";

        html += buildDayNotesHtml(pickDayNotes(state.dayNotes, d));

        if (isDayBlocked) {
          html += "<div class='seats-cal-empty'>" + TXT.closed + "</div>";
          html += "</td>";
          continue;
        }

        if (isPastDay) {
          html += "</td>";
          continue;
        }

        if (isClosed) {
          html += "<div class='seats-cal-empty'>" + TXT.closed + "</div>";
          html += "</td>";
          continue;
        }

        if (key === todayKey && isSameDayPolicyEnabled(STORE_KEY)) {
          html += "<div class='reservation-same-day-contact-slot'></div>";
          html += "</td>";
          continue;
        }

        var daySlots = pickDaySlots(state.byDay, d);

        var rows = [];
        var hadAnyRow = false;


        if (!daySlots.length) {
          if (isLoading) {
            html += "<div class='seats-cal-empty'>Loading...</div>";
            html += "</td>";
            continue;
          }

          // JIYUCHO: even when there is no slot data, build rows from allowed times
          if (STORE_KEY === "JIYUCHO") {
            rows = expandAllowedRowsForJiyucho_([], isWH);
            hadAnyRow = false;
          } else {

            // FUTO: treat "no data" as fully available and show the same 2 line summary as JIYUCHO
            if (STORE_KEY === "FUTO") {
              // console.log(d+"...A:" + STORE_KEY)
              var biz2 = bizHoursDisplay(STORE_KEY, dayStart);
              var bottomLine2 = isEnglishPage() ? "Rsvs Available" : "予約可";
              var hoursLine = getBusinessHoursLineForStore_(STORE_KEY, isWH, dayStart);

              html += "<div class='seats-cal-list'>";
              html += "  <div class='seats-cal-item summary-two-line' data-time='' data-avail='' data-to-close='0'>";
              html += "    <span class='t'>" + hoursLine + "</span>";
              html += "    <span class='a'>" + bottomLine2 + "</span>";
              html += "  </div>";
              html += "</div>";
              html += "</td>";
              continue;
            }
            // for open day with no data (other stores), show business hours line
            var biz2 = bizHoursDisplay(STORE_KEY, dayStart);
            var tBiz2 = biz2.open;
            var timeLabelBiz2 = biz2.label;

            var regularTwoLine = isEnglishPage();

            html += "<div class='seats-cal-list'>";
            html += "  <div class='seats-cal-item is-regular" + (regularTwoLine ? " regular-two-line" : "") + "' data-time='" + tBiz2 + "' data-avail='' data-to-close='0'>";
            html += "    <span class='t'>" + timeLabelBiz2 + "</span>";
            html += "    <span class='a'>" + TXT.regular + "</span>";
            html += "  </div>";
            html += "</div>";
            html += "</td>";
            continue;
          }
        }

        var MAX_SLOTS = (STORE_KEY === "FUTO") ? 12 : 5;

        // collect valid rows first
        if (daySlots.length) {
          rows = [];
          for (var m = 0; m < daySlots.length; m++) {
          var slot = daySlots[m];

          var t = fmtTimeJst(slot.from);
          if (!t) continue;

          var avail = parseInt(slot.avail, 10);
          if (!Number.isFinite(avail)) continue;

          rows.push({
              t: t,
              avail: avail,
              people: (slot.people != null ? parseInt(slot.people, 10) : null),
              memo: slot.memo || "",
              url: slot.url || ""
            });
          }
        }
        rows = filterRowsByLatestStartRule_(rows, STORE_KEY, dayStart);

        if (daySlots.length) hadAnyRow = rows.length > 0;

        // JIYUCHO: only show allowed times
        if (STORE_KEY === "JIYUCHO") {
          rows = expandAllowedRowsForJiyucho_(rows, isWH);
          rows = filterRowsByLatestStartRule_(rows, STORE_KEY, dayStart);
        }
        rows = filterRowsByLatestStartRule_(rows, STORE_KEY, dayStart);
        rows = applyMenuOverlapAvailability_(rows, dayStart);

        // JIYUCHO: show only business hours and availability (2 lines) ONLY when there is no reduction at any allowed time
        if (STORE_KEY === "JIYUCHO" && rows.length) {
          var hasFull = false;
          var hasReduced = false;
          var capMap2 = getAllowMapForJiyucho_(isWH) || {};

          for (var jj = 0; jj < rows.length; jj++) {
            var aJ = parseInt(rows[jj].avail, 10);
            if (aJ === 0) { hasFull = true; break; }

            var tJ = rows[jj].t;
            var capV2 = capMap2[tJ];
            var capN2 = (typeof capV2 === "number" && isFinite(capV2)) ? parseInt(capV2, 10) : null;

            // If we know the configured cap for this time, treat "avail < cap" as reduced.
            if (capN2 !== null && Number.isFinite(capN2)) {
              if (aJ < capN2) { hasReduced = true; break; }
            }
          }

          // summary only when all times are at full capacity (no full slots, no reduced slots)
          if (!hasFull && !hasReduced) {
            var hoursLine = getHoursLineFromRows_(rows) || getBusinessHoursLineForStore_(STORE_KEY, isWH, dayStart);
            var bottomLine = isEnglishPage() ? "Rsvs Available" : "予約可";

            html += "<div class='seats-cal-list'>";
            html += "  <div class='seats-cal-item summary-two-line' data-time='' data-avail='' data-to-close='0'>";
            html += "    <span class='t'>" + hoursLine + "</span>";
            html += "    <span class='a'>" + bottomLine + "</span>";
            html += "  </div>";
            html += "</div>";
            html += "</td>";
            continue;
          }
        }

        // FUTO: show only business hours and availability (2 lines) ONLY when there is no reduction at any shown time
        if (STORE_KEY === "FUTO" && rows.length) {
          var dayMaxF = -1;
          for (var jf0 = 0; jf0 < rows.length; jf0++) {
            var af0 = parseInt(rows[jf0].avail, 10);
            if (Number.isFinite(af0) && af0 > dayMaxF) dayMaxF = af0;
          }

          var hasFullF = false;
          var hasReducedF = false;

          if (dayMaxF > 0) {
            for (var jf1 = 0; jf1 < rows.length; jf1++) {
              var af1 = parseInt(rows[jf1].avail, 10);
              if (!Number.isFinite(af1)) continue;
              if (af1 === 0) { hasFullF = true; break; }
              if (af1 < dayMaxF) { hasReducedF = true; break; }
            }
          }

          if (!hasFullF && !hasReducedF && dayMaxF > 0) {
            var hoursLineF = getHoursLineFromRows_(rows) || getBusinessHoursLineForStore_(STORE_KEY, isWH, dayStart);
            var bottomLineF = isEnglishPage() ? "Rsvs Available" : "予約可";

            html += "<div class='seats-cal-list'>";
            html += "  <div class='seats-cal-item summary-two-line' data-time='' data-avail='' data-to-close='0'>";
            html += "    <span class='t'>" + hoursLineF + "</span>";
            html += "    <span class='a'>" + bottomLineF + "</span>";
            html += "  </div>";
            html += "</div>";
            html += "</td>";
            continue;
          }
        }

        if (!rows.length) {
          html += "<div class='seats-cal-empty'>" + (hadAnyRow ? TXT.out : TXT.plenty) + "</div>";
        } else {
          var lastIdx = rows.length - 1;

          var listHtml = "<div class='seats-cal-list'>";

          for (var i = 0; i < rows.length; i++) {
            var t2 = rows[i].t;
            var avail2 = rows[i].avail;

            // color classes
            // JIYUCHO: black when not reduced (avail >= configured cap), yellow only when reduced, red when full
            // Others: keep the old rule (<=2 => yellow, 0 => red)
            var levelClass = "";
            if (avail2 === 0) {
              levelClass = "lvl0";
            } else if (STORE_KEY === "JIYUCHO") {
              var capMap = getAllowMapForJiyucho_(isWH) || {};
              var capV = capMap[t2];
              var capN = (typeof capV === "number" && isFinite(capV)) ? parseInt(capV, 10) : null;

              if (capN !== null && Number.isFinite(capN)) {
                if (avail2 < capN) levelClass = "lvlLow";
              } else {
                if (avail2 <= 2) levelClass = "lvlLow";
              }
            } else {
              if (avail2 <= 2) levelClass = "lvlLow";
            }

            var isLast = (i === lastIdx);

            // 複数行ある日の最後だけ「以降」「til close」
            // var useToClose = isLast && (rows.length > 1);
            var useToClose = (STORE_KEY === "JIYUCHO") ? false : isLast;

            var isEn = isEnglishPage();

            // 英語の til close のときだけ 2 行表示にする
            var useTwoLine = isEn && useToClose;

            var itemCls = "seats-cal-item " + levelClass + (useTwoLine ? " to-close" : "");

            var timeLabel;
            if (isEn) {
              timeLabel = useToClose ? (t2 + " til close") : (t2 + " 〜");
            } else {
              timeLabel = useToClose ? (t2 + " 以降") : (t2 + " 〜");
            }

            var memo2 = rows[i].memo || "";
            var url2 = rows[i].url || "";
            var people2 = rows[i].people;

            // 満席シートの「満席行」扱い
            // C列 D列が共に 0 の行を想定
            var isMemoFullRow =
              avail2 === 0 &&
              (people2 === 0 || people2 === null) &&
              !!String(memo2).trim();

            if (isMemoFullRow) {
              listHtml += buildMemoHtml(timeLabel, memo2, url2, isEn, useTwoLine);
            } else {
              listHtml += "<div class='" + itemCls + "' data-time='" + t2 + "' data-avail='" + avail2 + "' data-to-close='" + (useToClose ? "1" : "0") + "'>";
              listHtml += "  <span class='t'>" + timeLabel + "</span>";
              listHtml += "  <span class='a'>" + seatText(avail2) + "</span>";
              listHtml += "</div>";
            }

          }

          listHtml += "</div>";
          html += listHtml;
        }

        html += "</td>";
      }
      html += "</tr>";
    }

    html += "      </tbody>";
    html += "    </table>";
    html += "  </div>";
    html += "</div>";

    container.innerHTML = html;
    var sameDayPolicy = getSameDayPolicy();
    if (sameDayPolicy && typeof sameDayPolicy.mountContact === "function") {
      var sameDaySlots = container.querySelectorAll(".reservation-same-day-contact-slot");
      for (var slotIndex = 0; slotIndex < sameDaySlots.length; slotIndex++) {
        sameDayPolicy.mountContact(sameDaySlots[slotIndex], STORE_KEY, "calendar");
      }
    }
  }

  async function run(container, state) {
    ensureStyle();

    // clamp: do not allow weeks before current week in JST
    if (!state.minStart) state.minStart = startOfWeekJst(new Date());

    var minStart = state.minStart;
    var anchorStart = startOfWeekJst(state.anchor);
    if (anchorStart.getTime() < minStart.getTime()) {
      state.anchor = minStart;
      anchorStart = minStart;
    }

    state.grid = buildGridDates(state.anchor);

    var startLabel = mdLabel(state.grid.start);
    var endLabel = mdLabel(addDays(state.grid.start, WEEKS * 7 - 1));
    var sep = isEnglishPage() ? " to " : " 〜 ";
    state.title = storeDisplayName(state.storeKey) + "<br>" + startLabel + sep + endLabel;

    state.disablePrev = (state.grid.start.getTime() <= minStart.getTime());

    var baseDate = startOfWeekJst(state.anchor);
    var baseParam = ymdParam(baseDate);
    var viewUrl = buildViewUrl(baseParam, state.storeKey);

    var cacheKey = normalizeStoreKey(state.storeKey) + "|" + baseParam;
    var cached = VIEW_CACHE[cacheKey];

    // instant render when cached
    if (cached && cached.byDay && Object.keys(cached.byDay).length > 0) {
      state.byDay = cached.byDay;
      state.dayNotes = cached.dayNotes || {};
      state.dayBlocks = cached.dayBlocks || {};
      publishCalendarByDay(state.storeKey, state.byDay);
      render(container, state, { loading: false });
      return;
    }

    // fast render placeholder (no blank screen)
    state.byDay = {};
    state.dayNotes = {};
    state.dayBlocks = {};
    render(container, state, { loading: true });

    try {
      var built = await window.JIYUCHO_SEATS_VIEW.buildBusinessSeatView(viewUrl, state.storeKey, { minAvail: 0 });

      var payload = (built && built.payload) ? built.payload : null;

      var byDay = {};
      var dayNotes = {};
      var dayBlocks = {};
      if (built && built.byDay && Object.keys(built.byDay).length > 0) {
        byDay = built.byDay;
        dayNotes = built.dayNotes || {};
        dayBlocks = built.dayBlocks || {};
      } else if (payload && Array.isArray(payload.slots) && payload.slots.length > 0) {
        byDay = buildByDayFromGasSlots_(payload, state.storeKey);
        dayNotes = built && built.dayNotes ? built.dayNotes : {};
        dayBlocks = built && built.dayBlocks ? built.dayBlocks : {};
      }

      // それでも空なら最後の保険として fetch
      var hasAny = false;
      try { hasAny = byDay && Object.keys(byDay).length > 0; } catch (e0) {}

      if (!hasAny) {
        var raw = payload || await fetch(viewUrl, { cache: "no-store" }).then(function (r) { return r.json(); });
        byDay = buildByDayFromGasSlots_(raw, state.storeKey);
        dayNotes = built && built.dayNotes ? built.dayNotes : {};
        dayBlocks = built && built.dayBlocks ? built.dayBlocks : {};
      }

      state.byDay = byDay;
      state.dayNotes = dayNotes;
      state.dayBlocks = dayBlocks;
      publishCalendarByDay(state.storeKey, state.byDay);

      // 空はキャッシュしない
      var hasAny2 = false;
      try { hasAny2 = state.byDay && Object.keys(state.byDay).length > 0; } catch (e1) {}
      if (hasAny2) VIEW_CACHE[cacheKey] = { byDay: state.byDay, dayNotes: state.dayNotes, dayBlocks: state.dayBlocks };
      else delete VIEW_CACHE[cacheKey];


      render(container, state, { loading: false });

      prefetchNeighbors(state.anchor, state.storeKey, minStart);

    } catch (e) {
      container.innerHTML =
        "<div class='seats-cal'><div style='padding:10px;white-space:pre-wrap;font-size:12px'>load failed<br><br>" +
        String(e && (e.stack || e.message || e)) +
        "</div></div>";
    }
  }

  function parseJstSlashDateToUtc_(s) {
    var m = /^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(String(s || "").trim());
    if (!m) return null;

    var y  = parseInt(m[1], 10);
    var mo = parseInt(m[2], 10);
    var d  = parseInt(m[3], 10);
    var hh = parseInt(m[4], 10);
    var mm = parseInt(m[5], 10);
    var ss = parseInt(m[6] || "0", 10);

    if (![y, mo, d, hh, mm, ss].every(Number.isFinite)) return null;

    // JST 表記を UTC に直す
    return new Date(Date.UTC(y, mo - 1, d, hh - 9, mm, ss));
  }


  function jstKeyFromUtcDate_(dUtc) {
    var j = new Date(dUtc.getTime() + 9 * 60 * 60 * 1000);
    return String(j.getUTCFullYear()) + "-" + pad2(j.getUTCMonth() + 1) + "-" + pad2(j.getUTCDate());
  }

  function jstMinFromUtcDate_(dUtc) {
    var j = new Date(dUtc.getTime() + 9 * 60 * 60 * 1000);
    return j.getUTCHours() * 60 + j.getUTCMinutes();
  }

  function buildByDayFromGasSlots_(raw, storeKey) {
    var slots = raw && raw.slots ? raw.slots : [];
    var out = {};

    for (var i = 0; i < slots.length; i++) {
      var row = slots[i];
      if (!row || row.length < 2) continue;

      var dt = parseJstSlashDateToUtc_(row[0]);
      if (!dt || isNaN(dt.getTime())) continue;

      var avail = parseInt(row[1], 10);
      if (!Number.isFinite(avail)) continue;

      var people = (row.length > 2 && row[2] != null) ? parseInt(row[2], 10) : null;
      var memo = (row.length > 3 && row[3] != null) ? String(row[3]) : "";
      var url = (row.length > 4 && row[4] != null) ? String(row[4]) : "";

      var key = jstKeyFromUtcDate_(dt);

      var parts = key.split("-");
      var y = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      var d = parseInt(parts[2], 10);
      if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) continue;

      var dayStart = window.JIYUCHO_SCHEDULE.jstDate(y, m, d, 0, 0, 0);
      var biz = bizHoursDisplay(storeKey, dayStart);

      var openMin = timeStrToMin(biz.open);
      var closeMin = biz.close ? timeStrToMin(biz.close) : (20 * 60);

      var tMin = jstMinFromUtcDate_(dt);

      if (Number.isFinite(openMin) && tMin < openMin) continue;
      if (Number.isFinite(closeMin) && tMin >= closeMin) continue;

      if (!out[key]) out[key] = [];
      out[key].push({
        from: dt,
        avail: avail,
        people: people,
        memo: memo,
        url: url,
        ymd: key,
        hour: (new Date(dt.getTime() + 9 * 60 * 60 * 1000)).getUTCHours()
      });
    }

    for (var k in out) {
      if (!Object.prototype.hasOwnProperty.call(out, k)) continue;
      out[k].sort(function (a, b) { return a.from.getTime() - b.from.getTime(); });
    }

    return out;
  }


  function publishCalendarByDay(storeKey, byDay) {
    try {
      if (!window.JIYUCHO_RESERVE_CALENDAR_DATA) window.JIYUCHO_RESERVE_CALENDAR_DATA = {};
      window.JIYUCHO_RESERVE_CALENDAR_DATA[normalizeStoreKey(storeKey)] = byDay || {};
    } catch (e) {}
  }

  function prefetchNeighbors(anchorDate, storeKey, minStart) {
    try {
      var step = WEEKS * 7;

      var a1 = addDays(anchorDate, step);
      var a2 = addDays(anchorDate, step * 2);

      var p1 = addDays(anchorDate, -step);
      var p2 = addDays(anchorDate, -step * 2);

      prefetchRange(a1, storeKey);
      prefetchRange(a2, storeKey);

      if (!minStart) minStart = startOfWeekJst(new Date());

      if (startOfWeekJst(p1).getTime() >= minStart.getTime()) prefetchRange(p1, storeKey);
      if (startOfWeekJst(p2).getTime() >= minStart.getTime()) prefetchRange(p2, storeKey);
    } catch (e) {}
  }

  function prefetchRange(anchorDate, storeKey) {
    try {
      var baseDate = startOfWeekJst(anchorDate);
      var baseParam = ymdParam(baseDate);
      var cacheKey = normalizeStoreKey(storeKey) + "|" + baseParam;
      if (VIEW_CACHE[cacheKey] && VIEW_CACHE[cacheKey].byDay) return;
      // mark inflight to avoid duplicate fetch
      if (VIEW_CACHE[cacheKey] && VIEW_CACHE[cacheKey].inflight) return;
      VIEW_CACHE[cacheKey] = { inflight: true };
      var viewUrl = buildViewUrl(baseParam, storeKey);
      window.JIYUCHO_SEATS_VIEW
        .buildBusinessSeatView(viewUrl, storeKey, { minAvail: 0 })
        .then(function (built) {
          VIEW_CACHE[cacheKey] = {
            byDay: (built && built.byDay) ? built.byDay : {},
            dayNotes: (built && built.dayNotes) ? built.dayNotes : {},
            dayBlocks: (built && built.dayBlocks) ? built.dayBlocks : {}
          };
        })
        .catch(function () {
          // keep empty cache on failure
          delete VIEW_CACHE[cacheKey];
        });
    } catch (e) {}
  }

  function bindMenuChangeCalendarRefresh(container, state) {
    var menu = document.getElementById("ReservationForm-menu");
    if (!menu || menu.__seatsCalendarMenuRefreshBound) return;
    menu.__seatsCalendarMenuRefreshBound = true;
    menu.addEventListener("change", function () {
      if (state && state.grid) render(container, state, { loading: false });
    });
  }

  function boot() {
    var container = document.getElementById("seatsCalendar");
    if (!container) return;
    if (container.__seatsCalendarState && typeof container.__seatsCalendarRun === "function") {
      container.__seatsCalendarState.storeKey = normalizeStoreKey(container.getAttribute("data-store") || (window.JIYUCHO_STORE_KEY || ""));
      bindMenuChangeCalendarRefresh(container, container.__seatsCalendarState);
      container.__seatsCalendarRun();
      return;
    }

    var raw = (container.getAttribute("data-store") || (window.JIYUCHO_STORE_KEY || ""));
    var storeKey = normalizeStoreKey(raw);

    var state = { anchor: new Date(), grid: null, byDay: {}, dayNotes: {}, dayBlocks: {}, title: "", storeKey: storeKey, minStart: startOfWeekJst(new Date()), disablePrev: false };
    bindMenuChangeCalendarRefresh(container, state);

    // single delegated handler (prev/next)
    if (!container.__seatsCalendarClickBound) container.addEventListener("click", function (ev) {
      var phoneLink = ev.target && ev.target.closest ? ev.target.closest('a[href^="tel:"]') : null;
      if (phoneLink) return;
      var btn = ev.target && ev.target.closest ? ev.target.closest("[data-act]") : null;
      if (btn) {
        var act = btn.getAttribute("data-act");
        if (act === "prev") {
          var cand = addDays(state.anchor, -(WEEKS * 7));
          var minStart = state.minStart || startOfWeekJst(new Date());
          if (startOfWeekJst(cand).getTime() < minStart.getTime()) return;
          state.anchor = cand;
          bindActiveScheduleInputTracker();
    run(container, state);
        } else if (act === "next") {
          state.anchor = addDays(state.anchor, (WEEKS * 7));
          bindActiveScheduleInputTracker();
    run(container, state);
        }
        return;
      }

      var item = ev.target && ev.target.closest ? ev.target.closest(".seats-cal-item") : null;
      var cell = ev.target && ev.target.closest ? ev.target.closest(".seats-cal-cell") : null;
      if (!cell) return;

      if (cell.classList && cell.classList.contains("is-closed")) return;
      if (cell.classList && cell.classList.contains("is-day-blocked")) return;

      var ymd = cell.getAttribute("data-ymd") || "";
      if (!ymd) return;

      var todayKey = ymdKey(new Date());
      if (ymd < todayKey) return;

      var time = item ? String(item.getAttribute("data-time") || "").trim() : "";
      var avail = item ? String(item.getAttribute("data-avail") || "").trim() : "";
      var targetInput = resolveActiveScheduleInput();
      if (item && time) {
        if (avail === "0") return;
        var dayDate = window.JIYUCHO_SCHEDULE.parseAsJSTLocalInput(ymd + "T00:00");
        if (!passLatestStartRuleForSlot_(state.storeKey, dayDate, time)) return;
        var changedInput = setChoiceDatetime(targetInput, ymd, time);
        scrollToScheduleField_(changedInput || targetInput);
        return;
      }
      if (window.JIYUCHO_RESERVATION_DATETIME_UI && typeof window.JIYUCHO_RESERVATION_DATETIME_UI.selectReservationDateForInput === "function") {
        var schedule1 = document.getElementById("ReservationForm-schedule1");
        var schedule2 = document.getElementById("ReservationForm-schedule2");
        if (schedule1) {
          window.JIYUCHO_RESERVATION_DATETIME_UI.selectReservationDateForInput(schedule1, ymd);
        }
        if (schedule2) {
          window.JIYUCHO_RESERVATION_DATETIME_UI.selectReservationDateForInput(schedule2, ymd);
        }
        scrollToScheduleField_(targetInput || schedule1 || schedule2);
      }
      return;
    });
    container.__seatsCalendarClickBound = true;
    container.__seatsCalendarState = state;
    container.__seatsCalendarRun = function () { bindActiveScheduleInputTracker(); run(container, state); };

    var sameDayPolicy = getSameDayPolicy();
    if (
      !container.__sameDayDateWatcherBound &&
      sameDayPolicy &&
      typeof sameDayPolicy.watchTokyoDateChange === "function" &&
      isSameDayPolicyEnabled(state.storeKey)
    ) {
      sameDayPolicy.watchTokyoDateChange(function () {
        state.minStart = startOfWeekJst(new Date());
        run(container, state);
      });
      container.__sameDayDateWatcherBound = true;
    }

    container.__seatsCalendarRun();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
